(function () {
  // header-menu.js measures --submenu-height / --full-open-header-height once,
  // when the top-level menu item opens. It re-measures on DOM node mutations
  // (e.g. deferred section hydration), but a <details> accordion toggling open
  // doesn't add or remove nodes -- the child list stays in the DOM the whole
  // time, the browser just changes how it's rendered -- so that observer never
  // fires for it, and the header's clip-path/position vars go stale, leaving
  // an accordion's expanded content to render outside the dropdown's painted
  // background. This listens for the accordion's native `toggle` event and
  // re-runs the same measurement/assignment header-menu.js does on open.
  function remeasure(details) {
    var submenu = details.closest('.menu-list__submenu');
    var headerComponent = document.getElementById('header-component');
    if (!submenu || !headerComponent) return;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var submenuHeight = submenu.offsetHeight;
        if (submenuHeight <= 0) return;

        var isOverlap = headerComponent.hasAttribute('data-submenu-overlap-bottom-row');
        var topRow = headerComponent.querySelector('.header__row--top');
        var headerVisibleHeight =
          isOverlap && headerComponent.offsetHeight > 0 && topRow
            ? topRow.offsetHeight
            : headerComponent.offsetHeight;

        headerComponent.style.setProperty('--submenu-height', submenuHeight + 'px');
        headerComponent.style.setProperty('--full-open-header-height', submenuHeight + headerVisibleHeight + 'px');
      });
    });
  }

  document.addEventListener(
    'toggle',
    function (event) {
      var target = event.target;
      if (target instanceof HTMLDetailsElement && target.classList.contains('mega-menu__accordion')) {
        remeasure(target);
      }
    },
    true
  );
})();
